// react
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// common
import PageLayout from "../../../common/shell/PageLayout";
import TaskLayout from "../../../common/shell/TaskLayout";
// me
import { IRootViewModel, RootViewModel } from "./models/models";
import * as actions from "./actions";
import DetailsView from "./views/DetailsView";

interface IRouteParameters {
    applicationId: string;
}

export default function Controller() {
    const { applicationId } = useParams<IRouteParameters>();
    // initial state
    const [vm, setVm] = useState<IRootViewModel>(new RootViewModel());

    // on mount
    useEffect(() => {
        actions.initialise(applicationId, setVm);

        // reset state when route changes
        return () => {
            setVm(new RootViewModel());
        };
    }, [applicationId]);

    return (
        <PageLayout title={[vm.titleNumber, vm.applicationTypeName]}>
            <TaskLayout isBusy={vm.isBusy} error={vm.error}>
                <DetailsView vm={vm} />
            </TaskLayout>
        </PageLayout>
    );
}
